
const StaticHeroBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Simple sphere background with CSS */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(/uplivion_sphere.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      
      {/* Subtle overlay for text readability */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(circle at center, transparent 20%, rgba(248, 249, 250, 0.1) 60%, rgba(248, 249, 250, 0.2) 100%)',
        }}
      />
      
      {/* Fallback gradient background */}
      <div 
        className="absolute inset-0 -z-10"
        style={{ 
          background: 'linear-gradient(135deg, #f8f9fa 0%, #f1f3f4 30%, #e8eaed 60%, #dee1e6 100%)',
        }}
      />
    </div>
  );
};

export default StaticHeroBackground;
